export const loadJS = function(url:string, location: HTMLElement,defer: boolean = false): Promise<string>{
    //url is URL of external file, implementationCode is the code
    //to be called from the file, location is the location to 
    //insert the <script> element

    const maybeScript: HTMLScriptElement = location.querySelector("script[src='"+ url + "']");

    if(!maybeScript) {
        return new Promise((resolve,reject) => {
            
            
            const scriptTag = document.createElement('script') as HTMLScriptElement;
            scriptTag.src = url;

            if(!defer) {
                scriptTag.async = true;
            }
            else scriptTag.defer = true;
            scriptTag.onload = () => resolve(url);
            scriptTag.onerror = () => reject("Error loading script @ " + url);
            if("onreadystatechange" in scriptTag) scriptTag['onreadystatechange'] = () => resolve(url);

            location.appendChild(scriptTag);
        })
    }
    else {
        return Promise.resolve(url);
    }
    
};



